









































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import {
    TransportLoad,
    TransportLoadTask,
    TransportTaskType,
} from "../models";

import {
    transportTaskTypeService,
    transportExecuteService
} from "../services";

@Component
export default class StartTaskDialog extends Vue {
    @Prop() item!: { load: TransportLoad, loadTask: TransportLoadTask };

    starting = false;

    taskTypes: null | TransportTaskType[] = null;
    selectedTaskType: null | TransportTaskType = null;

    async mounted() {
        this.taskTypes = await transportTaskTypeService.listTaskTypes();
    }

    async start() {
        this.starting = true;

        await transportExecuteService.startedTask(this.item.loadTask.task.taskId, {
            taskTypeId: this.selectedTaskType!.taskTypeId
        });

        this.$emit("reload");
    }
}
